export default "__VITE_ASSET__CYQG05S6__"